var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#827c78",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.3,
    d: "M21.3 4.95C26.54 7.18 30 12.226 30 17.889 30 25.682 23.507 32 15.5 32 7.492 32 1 25.682 1 17.888 1 12.226 4.459 7.181 9.698 4.951c.667-.284 1.444.012 1.736.661a1.27 1.27 0 0 1-.68 1.69c-4.288 1.825-7.118 5.953-7.118 10.586 0 6.377 5.312 11.546 11.864 11.546 6.551 0 11.864-5.17 11.864-11.546 0-4.634-2.831-8.762-7.12-10.586a1.27 1.27 0 0 1-.68-1.69c.29-.649 1.068-.945 1.735-.661zm-5.8 10.372c-.729 0-1.319-.574-1.319-1.282V2.283c0-.709.59-1.283 1.318-1.283.728 0 1.319.574 1.319 1.283V14.04c0 .708-.59 1.282-1.319 1.282z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b91716c33ee8fd6019c25069c224f150.svg";
export { ForwardRef as ReactComponent };